import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModules } from "src/app/shared.modules";
import { FormsModule } from "@angular/forms";
import { DialogTopHalosComponent } from "./dialog-top-halos.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { DialogDefaultModalComponent } from "../dialog-default-modal/dialog-default-modal.component";
@NgModule({
  declarations: [DialogTopHalosComponent],
  imports: [
    CommonModule,
    SharedModules,
    AngularSvgIconModule,
    DialogDefaultModalComponent,
  ],
})
export class DialogTopHalosModule {}
